var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "footer-bar" },
    [
      _c(
        "div",
        { staticClass: "select-all-btn" },
        [
          _c(
            "van-checkbox",
            {
              attrs: {
                value: _vm.checkAll,
                "checked-color": "#005423",
                "icon-size": "0.43rem"
              },
              on: { click: _vm.onChange }
            },
            [_vm._v(" 全选 ")]
          )
        ],
        1
      ),
      _c("div", { staticClass: "summary" }, [
        _c("span", [_vm._v("合计：")]),
        _c("span", { staticClass: "red-money" }, [
          _vm._v(_vm._s(_vm._f("formatPrice")(_vm.money)))
        ])
      ]),
      _c(
        "mobile-button",
        {
          staticClass: "operate-btn__fee",
          attrs: { color: "#ab2c31" },
          on: { click: _vm.onSubmit }
        },
        [_vm._v(" 去交费 ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }